declare var jQuery:any;
declare var $:any;

// Imports Angular
import { BrowserModule } from '@angular/platform-browser';
import { NgModule, Compiler } from '@angular/core';
import { Http, HttpModule } from '@angular/http';
import { FormsModule } from '@angular/forms';
import { BrowserAnimationsModule, NoopAnimationsModule } from '@angular/platform-browser/animations';

// External Modules
import { FlexLayoutModule } from '@angular/flex-layout';
import { MaterialModule } from './configuracion/material.module';
import { SessionStorageService } from 'ngx-webstorage';
import { Ng2Webstorage } from 'ngx-webstorage';
import { CookieService } from 'angular2-cookie/services/cookies.service';
import { Logger } from 'angular2-logger/core';

// Components view
import { AppComponent } from './app.component';
import { GestorFirmasComponent } from './components/gestor-firmas/gestor-firmas.component';
import { SelectorComponent } from './components/selector/selector.component';
import { DFirmaComponente } from '@dian-cmp/firma';
import { DEnvioLogComponente } from '@dian-cmp/envio-log';
import { DNotificacionesComponente } from '@dian-cmp/notificaciones';
import { DNotificacionServicio } from '@dian-cmp/notificaciones';

// Libs framework
import { DLogger } from '@dian/core';
import { DLoggerAngular } from '@dian/core';
import { DContextoMuiscaServicio } from '@dian/core';
import { DSessionStorage } from '@dian/core';
import { DContextoMuiscaDesaServicio } from '@dian/core';
import { DFormularioServicio } from '@dian/api-formulario';
import { FiltroFormatosPipe } from './pipes/filtro-formatos.pipe';
import { ArraySortPipe } from './pipes/array-sort.pipe';
import { MessageService } from './resources/services/message.service';

// Conf
import { loggerFactory, contextoMuiscaFactory, formularioFactory, sessionStorageFactory } from './configuracion/app.factories';
import { AppRoutingModule } from './app-routing.module';
import { FormatosComponent } from './resources/components/formatos/formatos.component';


@NgModule({
  declarations: [
    AppComponent,
    GestorFirmasComponent,
    SelectorComponent,
    DNotificacionesComponente,
    DFirmaComponente,
    DEnvioLogComponente,
    FiltroFormatosPipe,
    ArraySortPipe,
    FormatosComponent
  ],
  imports: [
    //Angular
    BrowserModule,
    HttpModule, 
    FormsModule,
    BrowserAnimationsModule,
    NoopAnimationsModule,
    //External
    Ng2Webstorage.forRoot({ 
      prefix: 'DIAN', 
      separator: '-', 
      caseSensitive:true 
    }),
    //Material
    FlexLayoutModule,
    MaterialModule,
    //Aplicacion
    AppRoutingModule 
  ],
  providers: [
    CookieService, 
    Compiler,
    Logger,
    DNotificacionServicio,
    {
        provide: DLogger,
        useFactory: loggerFactory,
        deps: [Logger, SessionStorageService]
    },
    {
        provide: DSessionStorage,
        useFactory: sessionStorageFactory,
        deps: [SessionStorageService,DLogger]
    },
    {
        provide: DContextoMuiscaServicio,
        useFactory: contextoMuiscaFactory,
        deps: [Http, CookieService, Compiler, DLogger, DNotificacionServicio, DSessionStorage]
    },
    {
        provide:  DFormularioServicio,
        useFactory: formularioFactory,
        deps: [DContextoMuiscaServicio]            
    },
    MessageService  
  ],
  bootstrap: [
    AppComponent
  ],
  entryComponents: [
    DNotificacionesComponente, 
    DEnvioLogComponente,
    DFirmaComponente
  ]
})
export class AppModule { }



// WEBPACK FOOTER //
// D:/AngularProjects/Angular Projects/Formularios/src/app/app.module.ts